export default "__VITE_ASSET__CRSkzMqb__"